<input-phone [fc]="formGroup.get('phone')" [errors]="errorsPhone" [label]="'LABELS.MOBILE_NUMBER'" [id]="'phone'"></input-phone>
